import {useCallback, useRef, useState} from 'react'
import {TextareaAutosize, Typography} from '@mui/material'
import '@fontsource/roboto'

import { sumAsteroidTypes } from '../model/AsteroidStats'
import parseItems, { ParsedItem } from '../model/ItemParser'
import AsteroidStats from '../components/AsteroidStats'

import style from './AsteroidCalc.module.css'

const AsteroidCalc = () => {
  const generateStatsButton = useRef<HTMLButtonElement>(null)

  const [surveyText, setSurveyText] = useState('')
  const [parsedItems, setParsedItems] = useState<Array<ParsedItem>>([])

  const parseItemsNow = () => {
    const items = parseItems(surveyText)
    const asteroidTypes = sumAsteroidTypes(items)
    setParsedItems(asteroidTypes)
  }

  const activateButton = useCallback(event => {
    setSurveyText(event.clipboardData.getData('text/plain'))
    generateStatsButton.current?.focus()
  }, [setSurveyText])

  return (
    <div className={ style.app }>
      <div className={ style.pageContent }>
        <div className={ style.textInput }>
          <TextareaAutosize minRows='5' maxRows='15' className={ style.textarea } value={ surveyText } onChange={ (event) => setSurveyText(event.target.value) } onPaste={ activateButton }/>
          <div className={ style.spacer }/>
          <button ref={ generateStatsButton } onClick={ parseItemsNow }>Generate Stats</button>
          <Typography className={ style.text }>
            This is a small helper to gauge the distribution of ore in an asteroid belt.
            Install a survey scanner (preferrably in a Porpoise or an Orca, due to range) and activate it in the middle of the belt.
            In the window that opens select everything (Ctrl-A) and copy it to the clipboard (Ctrl-C), then paste it into the text field above.
          </Typography>
          <Typography className={ style.text }>
            If this app is useful to you, or if you think it should do more, don’t hesitate to contact me via in-game mail to <em>Ajaqa Chajij</em>.
            You can also send ISK! 😁
          </Typography>
        </div>
        <div className={ style.typeStats }>
          <AsteroidStats items={ parsedItems }/>
        </div>
      </div>
    </div>
  )
}

export default AsteroidCalc
